var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDistributor)?_c('DistributorHome'):(_vm.isInstaller)?_c('InstallerHome'):_c('ProductionHome')}
var staticRenderFns = []

export { render, staticRenderFns }